<template>
<v-content mx-auto class="boom" >
  <el-form :model="loginForm" :rules="loginRules" ref="loginForm" label-position="left" label-width="auto"
           class="demo-ruleForm login-container">
    <h3 class="title">Login Here</h3>
    <el-form-item prop="account">
      <i class="el-icon-phone">Account</i>
      <effect-input id="account" @keyup.native.enter="login" type="hoshi" v-model="loginForm.account" auto-complete="on" placeholder="Account" label="Email"></effect-input>
    </el-form-item>
    <el-form-item prop="checkpass">
      <i class="el-icon-view">Password</i>
      <effect-input type="hoshi" @keyup.native.enter="login" v-model="loginForm.checkPass" auto-complete="on" placeholder="Password" label="password"></effect-input>
    </el-form-item>
    <el-checkbox v-model="checked" class="remember" true-label="remember">Remember password?</el-checkbox>
    <el-form-item>
     <el-button @click="submitForm('loginForm');login()" type="primary" class="loginBtn2">Login
      </el-button>
    </el-form-item>
       <el-form-item style="width:100%;">
      <el-button type="primary" class="loginBtn"
                 @click.native.prevent="signInWithGoogle" :loading="logining">Login with Google
      </el-button>
    </el-form-item>
      <router-link to="/register">No account? Register now!</router-link>
  </el-form>
</v-content>
</template>

<script>
/* eslint-disable */
// eslint-disable-next-line
import firebase from 'firebase';
import '../store.js'
import '@/components/icon.css'

  export default {
    name:'login',
    computed: {
      user () {
        return this.$store.getters.user
      },
      error () {
        return this.$store.getters.error
      },
      loading () {
        return this.$store.getters.loading
      }
    },
    methods: { 
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
         if (valid) {
            const self = this;
            //判断复选框是否被勾选 勾选则调用配置cookie方法
            if (self.checked == true) {
                //传入账号名，密码，和保存天数3个参数
                self.setCookie(self.loginForm.account, self.loginForm.checkPass, 7);
            }else {
              console.log("清空Cookie");
              //清空Cookie
              self.clearCookie();
          }
          console.log("successful login");
          }
        });
      },
  
      //设置cookie
      setCookie(c_name, c_pwd, exdays) {
          var exdate = new Date(); //获取时间
          exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
          //字符串拼接cookie
          window.document.cookie = "account" + "=" + c_name + ";path=/;expires=" + exdate.toGMTString();
          window.document.cookie = "checkpass" + "=" + c_pwd + ";path=/;expires=" + exdate.toGMTString();
      },
      //读取cookie
      getCookie: function() {
          if (document.cookie.length > 0) {
              var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
              for (var i = 0; i < arr.length; i++) {
                  var arr2 = arr[i].split('='); //再次切割
                  //判断查找相对应的值
                  if (arr2[0] == 'account') {
                    //  console.log(arr2[1])
                      this.loginForm.account = arr2[1]; //保存到保存数据的地方
                  } else if (arr2[0] == 'checkpass') {
                    // console.log(arr2[1])
                      this.loginForm.checkPass = arr2[1];
                  }
              }
               this.checked = true;
          }
      },
      //清除cookie
      clearCookie: function() {
          this.setCookie("", "", -1); //修改2值都为空，天数为负1天就好了
      },

signInWithGoogle() {
 var provider = new firebase.auth.GoogleAuthProvider();
     firebase
     .auth()
     .signInWithPopup(provider)
     .then(function(result) {
  var token = result.credential.accessToken;
  // The signed-in user info.
  var user = result.user;
}).catch(function(error) {
  
  var errorCode = error.code;
  var errorMessage = error.message;
  var email = error.email;
  var credential = error.credential;
}).then(
  user => {
  alert('successful login! as ${user.account}');
    this.$router.push({path:"/"});
  this.$router.go({path: this.$router.path});
},
err =>{
alert('something wrong? check your google account or password.')
}
);
},
login: function(e) {
firebase
.auth()
.signInWithEmailAndPassword(this.loginForm.account, this.loginForm.checkPass)
.then(
user => {
  alert('successful login!');
    this.$router.push({path:"/"});
    this.$router.go({path: this.$router.path});
},
err => {
  alert(err.message);
}
);
e.preventDefault();
}  
  },
    data(){
      return {
        logining: false,
        loginForm: {
          account: '',
          checkPass: ''
         },
        loginRules: {
          account: [
            {required: true, message: 'please type your account', trigger: 'blur'},
          ],
          checkPass: [
            {required: true, message: 'please type your password', trigger: 'blur'},
          ]
         },
        checked: true 
       }
     },
      mounted() {
        this.getCookie();
    }

  }
</script>

<style lang="scss" scoped>
.boom{
background-size: 100%;
background:url(../assets/pengke.webp);
background-repeat: no-repeat;
background-position:center;
background-attachment:fixed;

}
  .login-container {
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 80px auto;
    width: auto;
    max-width: 400px;
    padding: 35px 35px 45px 35px;
    border: 1px solid #eaeaea;
    background: #1a202486;
    color: #fff;
  .title {
    width: 100%;
    margin: 0px auto 40px auto;
    text-align: center;
  }
  .remember {
    color: #000;
    margin: 0px 0px 35px 0px;
  }
  .loginBtn {
    width: 100%;
    font-size: 20px;
    letter-spacing: 5px;
  }
  .loginBtn2 {
    width: 100%;
    margin-top: 10px;
    font-size: 20px;
    letter-spacing: 10px;
  }
  input:-moz-placeholder {
    color: rgb(252, 252, 252);
    opacity: 1;
    font-size: 14px;
}
  }
</style>
